import { useEffect, useState } from "react";
import { AuthPage } from "../../common/components/template_page/auth";
import { ConfirmScreen } from "./screens/confirm";
import { RegisterScreen } from "./screens/register";
import { SuccessScreen } from "./screens/success";
import { IStateScreen } from "./dtos";
import { useSearchParams } from "react-router-dom";
import { saveLocalData } from "../../common/helpers/localData";

export const Register = () => {
  
  const [screen, setScreen] = useState<IStateScreen>({
    currentScreen: 1, who: ""
  });

  const [params] = useSearchParams();
  const search = params.get('ref')

  useEffect(() => {
    if (!search) return;
    saveLocalData('loginRedirect', search);
  }, [])

  return (
    <AuthPage>
      <>
        {(() => {
          if (screen.currentScreen === 1)
            return <RegisterScreen stateScreen={screen} dispatchScreen={setScreen} />

          if (screen.currentScreen === 2)
            return <ConfirmScreen stateScreen={screen} dispatchScreen={setScreen} />

          if (screen.currentScreen === 3)
            return <SuccessScreen />
        })()}
      </>
    </AuthPage>
  )
}